module.exports = __webpack_public_path__ + "img/tip-image-1.2895dc7e.png";